<template>
  <v-container>
    <v-tabs
      class="v-tabs--pill"
      dark
      hide-slider
      active-class="primary white--text"
      v-model="tab"
      show-arrows
      background-color="transparent"
      centered
      icons-and-text
    >
      <v-tab
        :class="
          `${$vuetify.theme.dark ? 'white' : 'black'}--text font-weight-medium`
        "
        v-for="item in items"
        :key="item"
      >
        {{ item }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" class="pt-12 transparent">
      <v-tab-item>
        <keep-alive>
          <resume :variablesTags="variablesTags"></resume
        ></keep-alive>
      </v-tab-item>
      <v-tab-item>
        <variables :variablesTags="variablesTags"></variables>
      </v-tab-item>
      <v-tab-item>
        <multimedia />
      </v-tab-item>
      <v-tab-item>
        <metax-chat></metax-chat>
      </v-tab-item>
    </v-tabs-items>
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          color="primary"
          fixed
          bottom
          left
          :small="$vuetify.breakpoint.smAndDown"
          v-on="on"
          @click="
            $router.push(
              `/equipment/${inspectionProfile.equipmentProfile.id}/inspections`
            )
          "
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("inspectionProfile.backbtn") }}</span>
    </v-tooltip>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ProfileInspection",
  components: {
    resume: () => import("./Resume"),
    variables: () => import("./Variables"),
    multimedia: () => import("./Multimedia/Index"),
    "metax-chat": () => import("@/components/Inspections/Chat/Index.vue")
  },
  data: function() {
    return {
      tab: null,
      items: [
        this.$t("inspectionProfile.summary"),
        this.$t("inspectionProfile.variables"),
        this.$t("inspectionProfile.multimedia"),
        "Chat"
      ]
    };
  },
  async created() {
    const loading = this.$vs.loading({
      background: "#730D0B",
      color: "rgb(255, 255, 255)",
      opacity: 1,
      type: "square"
    });
    try {
      await this.$store.dispatch(
        "inspections/bindAnInspection",
        this.$route.params.id
      );
      loading.close();
    } catch (error) {
      loading.close();
      this.$router.push("Error");
    }
  },
  computed: {
    ...mapState("inspections", ["inspectionProfile"]),
    variablesTags() {
      let tags = new Map();
      if (this.inspectionProfile?.equipmentProfile?.variables?.length > 0) {
        this.inspectionProfile.equipmentProfile.variables.forEach(variable => {
          if (variable.tagName) tags.set(variable.code, variable.tagName);
        });
      }

      return tags;
    }
  }
};
</script>

<style></style>
